import Footer from "./Footer";
import NavbarComp from "./NavbarComp";






const Reg = () => {
    return (  
<div className="bg-light animated fadeInUp ease-in-quint d-1 a-2">
<NavbarComp />
<h1 className="exee text-center mt-5">Membership Registration</h1>
<p className="fw-bold text-center text-muted mt-5 text-white">Register with us to become a member so we can keep you up to date on all AMCOSA news.having an alma mater in common and being able to network via regular in-person events or online platforms for connections.</p>
<div className="login-box col-10 col-lg-8">
 
 
  <form>
    <div className="user-box">
      <input type="text" name="" required="" />
      <label>Surname</label>
    </div>
    <div className="user-box">
      <input type="text" name="" required="" />
      <label>Firstname</label>
    </div>
    <div className="user-box">
      <input type="number" name="" required="" />
      <label>Phone number</label>
    </div>
    <div className="user-box">
      <input type="text" name="" required="" />
      <label>Current institution</label>
    </div>
    <div className="user-box">
      <input type="text" name="" required="" />
      <label>Email address</label>
    </div>
    <div className="user-box">
      <input type="text" name="" required="" />
      <label>Sex</label>
    </div>
    <div>
    <label className="text-white" for="years">Year of graduation:</label>

<select >
  <option value="volvo">Select your year of graduation</option>
  <option value="2010">2010</option>
  <option value="2011">2011</option>
  <option value="2012">2012</option>
  <option value="2013">2013</option>
  <option value="2014">2014</option>
  <option value="2015">2015</option>
  <option value="2016">2016</option>
  <option value="2017">2017</option>
  <option value="2018">2018</option>
  <option value="2019">2019</option>
  <option value="2020">2020</option>
  <option value="2021">2021</option>
  <option value="2022">2022</option>
  <option value="2023">2023</option>
</select>
    </div>
    <a type="submit" href="#">
      <span className="spans"></span>
      <span className="spans"></span>
      <span className="spans"></span>
      <span className="spans"></span>
      Submit
    </a>
    
  </form>
</div>



<div>
    <Footer />
</div>
</div>




    );
}
 
export default Reg;